import { useNavigate } from "react-router-dom";
import { ChevronLeft, ClipboardList } from "lucide-react";

export default function Surveys() {
  const navigate = useNavigate();
  return (
    <div className="page fade-in" data-testid="surveys-page">
      <button
        onClick={() => navigate(-1)}
        data-testid="surveys-back-button"
        style={{
          width: 44, height: 44, borderRadius: 22,
          background: "var(--surface)", border: "1px solid var(--border)",
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: "0 8px 24px -16px rgba(11,36,71,0.2)",
        }}
      >
        <ChevronLeft size={22} color="var(--text-primary)" />
      </button>

      <h1 style={{ fontSize: 32, fontWeight: 800, letterSpacing: -1, margin: 0, marginTop: 18 }}>
        Earn on Surveys
      </h1>
      <p style={{ color: "var(--text-secondary)", fontSize: 14, marginTop: 6 }}>
        Share your opinions and earn extra cashback.
      </p>

      <div style={{
        marginTop: 36, textAlign: "center",
        background: "var(--surface)", border: "1px solid var(--border)",
        borderRadius: 28, padding: "40px 24px",
      }}>
        <div style={{
          width: 84, height: 84, margin: "0 auto", borderRadius: 24,
          background: "var(--primary-soft)",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <ClipboardList size={40} color="var(--primary-dark)" />
        </div>
        <h2 style={{ marginTop: 20, fontSize: 22, fontWeight: 800, letterSpacing: -0.4 }}>
          No surveys available right now
        </h2>
        <p style={{ color: "var(--text-secondary)", fontSize: 14, marginTop: 10, lineHeight: 1.5 }}>
          We're working with our partners to bring you paid surveys soon. Check back here — we'll notify you when new surveys land.
        </p>
      </div>
    </div>
  );
}
